'use client';

import { styles } from './HeaderBlock.styles';

export interface HeaderBlockProps {
  /** Заголовок блока */
  title: string;
  /** Описание акции */
  description?: string;
}

export function HeaderBlock({ title, description }: HeaderBlockProps) {
  const slots = styles();

  if (!title && !description) {
    return null;
  }

  return (
    <div className={slots.base()}>
      <div className={slots.title()}>{title}</div>
      <div
        className={slots.description()}
        dangerouslySetInnerHTML={{ __html: description ?? '' }}
      />
    </div>
  );
}
